import { render, staticRenderFns } from "./HelpSeventhPage.vue?vue&type=template&id=333c99de&"
import script from "./HelpSeventhPage.vue?vue&type=script&lang=js&"
export * from "./HelpSeventhPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports